import React from 'react';
import styled from 'styled-components';

interface LiveBadgeProps {
  liveTime: string;
  isMobile?: boolean;
  className?: string;
}

// 라이브 배지 (모바일용)
const MobileLiveBadge = styled.div`
  height: 20px;
  background-color: #f3f3f3;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 6px;
  font-size: 12px;
  font-weight: 500;
  color: #000;
  white-space: nowrap;
  min-width: fit-content;
`;

// 라이브 배지 (데스크톱용)
const DesktopLiveBadge = styled.div`
  height: 29px;
  background-color: #f3f3f3;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  white-space: nowrap;
  min-width: fit-content;
`;

// 라이브 인디케이터 (빨간 원)
const LiveIndicator = styled.div`
  width: 6px;
  height: 6px;
  background-color: #ed2424;
  border-radius: 50%;
`;

const LiveBadge: React.FC<LiveBadgeProps> = ({ 
  liveTime, 
  isMobile = false, 
  className 
}) => {
  const BadgeComponent = isMobile ? MobileLiveBadge : DesktopLiveBadge;
  
  return (
    <BadgeComponent className={className}>
      <LiveIndicator />
      {liveTime}
    </BadgeComponent>
  );
};

export default LiveBadge;
